import { ControlAttributeType, } from "@cloudpivot/form/typings";
import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "visible", "style", "tips", "dataItemName", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: ["prefix", "maxLength", "resetDate", "delimiter"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "单据号" }),
        // 流水号编码
        prefix: {
            options: {
                regexps: {
                    maxLength: {
                        len: 200,
                        message: "长度不能超过200字节",
                    },
                },
            },
        },
        // 最大长度
        maxLength: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "4",
                        label: "4",
                    },
                    {
                        value: "5",
                        label: "5",
                    },
                    {
                        value: "6",
                        label: "6",
                    },
                    {
                        value: "7",
                        label: "7",
                    },
                    {
                        value: "8",
                        label: "8",
                    },
                    {
                        value: "9",
                        label: "9",
                    },
                    {
                        value: "10",
                        label: "10",
                    },
                ],
            },
        },
        // 重置策略时间
        resetDate: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "none",
                        label: "不重置",
                    },
                    {
                        value: "DAY",
                        label: "每天",
                    },
                    {
                        value: "MONTH",
                        label: "每月",
                    },
                    {
                        value: "YEAR",
                        label: "每年",
                    },
                ],
            },
        },
        // 连接符
        delimiter: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                allowClear: true,
                list: [
                    {
                        value: "mark1",
                        label: "-",
                    },
                    {
                        value: "mark2",
                        label: "#",
                    },
                    {
                        value: "mark3",
                        label: "_",
                    },
                ],
                callback: (key, attr, attrs, vm) => {
                    let val = attr.value || "";
                    vm.updateAttribute(key, "delimiter", val);
                },
            },
        },
    },
};
